import { actionGenerator } from "utils";

const PREFIX = "HOME";

export const GET_PROVINCES = actionGenerator.genActionTypes(
  `${PREFIX}_GET_PROVINCES`
);

export const REQUEST_SMS_OTP = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_SMS_OTP`
);

export const REQUEST_EMAIL_OTP = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_EMAIL_OTP`
);

export const OTP_LOG = actionGenerator.genActionTypes(`${PREFIX}_OTP_LOG`);

export const VERIFY_OTP = actionGenerator.genActionTypes(
  `${PREFIX}_VERIFY_OTP`
);

export const REQUEST_LOGIN = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_LOGIN`
);

export const UPDATE_USER_INFO = actionGenerator.genActionTypes(
  `${PREFIX}_UPDATE_USER_INFO`
);

export const REQUEST_GIGYA = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_GIGYA`
);

export const EXCHANGE_CODE = actionGenerator.genActionTypes(
  `${PREFIX}_EXCHANGE_CODE`
);

export const TOPUP_MOBILE = actionGenerator.genActionTypes(
  `${PREFIX}_TOPUP_MOBILE`
);

export const GET_DISTRICTS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_DISTRICTS`
);

export const GET_MARTS = actionGenerator.genActionTypes(`${PREFIX}_GET_MARTS`);

export const UPDATE_DELIVERY = actionGenerator.genActionTypes(
  `${PREFIX}_UPDATE_DELIVERY`
);

export const CHECK_PHONE = actionGenerator.genActionTypes(
  `${PREFIX}_CHECK_PHONE`
);

export const RESET_PASSWORD = actionGenerator.genActionTypes(
  `${PREFIX}_RESET_PASSWORD`
);

export const GET_NEWS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_NEWS`
);

export const GET_POINTS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_POINT`
);

export const GET_GIFT_LIST = actionGenerator.genActionTypes(
  `${PREFIX}_GET_GIFT_LIST`
);

export const GET_GIFT_DETAIL = actionGenerator.genActionTypes(
  `${PREFIX}_GET_GIFT_DETAIL`
);

export const GET_MY_GIFTS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_MY_GIFTS`
);

export const GET_MY_GIFT_DETAIL = actionGenerator.genActionTypes(
  `${PREFIX}_GET_MY_GIFT_DETAIL`
);

export const REDEEM_GIFT = actionGenerator.genActionTypes(
  `${PREFIX}_REDEEM_GIFT`
);

export const USE_GIFT = actionGenerator.genActionTypes(
  `${PREFIX}_USE_GIFT`
);

//kietnva
export const GET_SLOTS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_SLOTS`
);
export const BOOK_TICKET = actionGenerator.genActionTypes(
  `${PREFIX}_BOOK_TICKET`
);
// PS 8/3
export const GET_CAMPAIGN_INFO = actionGenerator.genActionTypes(
  `${PREFIX}_GET_CAMPAIGN_INFO`
);
export const GET_CARDS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_CARDS`
);
export const COUNT_CARDS = actionGenerator.genActionTypes(
  `${PREFIX}COUNT_CARDS`
);
export const DETECT_IMAGE = actionGenerator.genActionTypes(
  `${PREFIX}DETECT_IMAGE`
);
export const DETECT_TEXT = actionGenerator.genActionTypes(
  `${PREFIX}DETECT_TEXT`
);
export const CREATE_CARD = actionGenerator.genActionTypes(
  `${PREFIX}CREATE_CARD`
);
